module.exports = "/7/0-lam-quen-voi-khai-niem-function/index.html.6701f9806c1a33418b356bcbfebc4392.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30132.md
 ** module id = 560
 ** module chunks = 0
 **/